// extracted by mini-css-extract-plugin
export default {"thanks":"thankYou_thanks__q1JsT","message":"thankYou_message__VjAh1"};